<template>
  <div>
    <!-- Clear Filters -->
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>

    <form @submit.prevent="handleFilters">
      <div class="row filter-row">
        <!-- Division -->
        <div class="col-sm-6 col-md-2 position-relative">
          <div class="input-block mb-3 form-focus select-focus">
            <vue-select
              :style="`${
                filters.division_id &&
                'border-bottom: var(--primary-color) 2px solid;'
              }`"
              :options="divisions"
              v-model="filters.division_id"
              placeholder="Select Division"
            />

            <label class="focus-label"> Division </label>
          </div>

          <i
            v-if="filters.division_id"
            @click="handleClearOneFilter('division_id')"
            class="fa-solid fa-x"
            :style="{
              position: 'absolute',
              top: '-20px',
              right: '0px',
              cursor: 'pointer',
            }"
          ></i>
        </div>

        <!-- Month + Year -->
        <div class="col-sm-6 col-md-2 position-relative">
          <div
            class="input-block mb-3 form-focus"
            :class="{ focused: filters.month_year }"
          >
            <input
              type="month"
              class="form-control floating"
              v-model="filters.month_year"
              :style="`${
                filters.month_year &&
                'border-bottom: var(--primary-color) 2px solid;'
              }`"
            />

            <label class="focus-label"> Month / Year </label>
          </div>

          <i
            v-if="filters.month_year"
            @click="handleClearOneFilter('month_year')"
            class="fa-solid fa-x"
            :style="{
              position: 'absolute',
              top: '-20px',
              right: '0px',
              cursor: 'pointer',
            }"
          ></i>
        </div>

        <!-- Status -->
        <div class="col-sm-6 col-md-2 position-relative">
          <div class="input-block mb-3 form-focus select-focus">
            <vue-select :sort="false"
              :style="`${
                filters.cfo_status &&
                'border-bottom: var(--primary-color) 2px solid;'
              }`"
              :options="statuses"
              v-model="filters.cfo_status"
              placeholder="Select Status"
            />

            <label class="focus-label"> Status </label>
          </div>

          <i
            v-if="filters.cfo_status"
            @click="handleClearOneFilter('cfo_status')"
            class="fa-solid fa-x"
            :style="{
              position: 'absolute',
              top: '-20px',
              right: '0px',
              cursor: 'pointer',
            }"
          ></i>
        </div>

        <!-- Has Merge -->
        <div class="col-sm-6 col-md-2 position-relative">
          <div class="input-block mb-3 form-focus select-focus">
            <vue-select
              :style="`${
                filters.has_merge &&
                'border-bottom: var(--primary-color) 2px solid;'
              }`"
              :options="mergeOptions"
              v-model="filters.has_merge"
              placeholder="Select Merge"
            />

            <label class="focus-label"> Has Merge </label>
          </div>

          <i
            v-if="filters.has_merge"
            @click="handleClearOneFilter('has_merge')"
            class="fa-solid fa-x"
            :style="{
              position: 'absolute',
              top: '-20px',
              right: '0px',
              cursor: 'pointer',
            }"
          ></i>
        </div>

        <!-- Buttons -->
        <div class="d-flex col-sm-6 col-md-3 gap-2">
          <button type="submit" class="btn btn-success w-100">Search</button>

          <button
            type="button"
            class="btn btn-success w-100"
            @click="resetAllFilters"
          >
            Reset
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import DivisionService from "@/services/DivisionService";

export default {
  data() {
    return {
      filters: {
        division_id: "",
        month_year: "",
        cfo_status: "",
        has_merge: "",
      },

      divisions: [],

      statuses: ["pending", "approved"],

      mergeOptions: ["yes", "no"],

      searched: false,
    };
  },

  methods: {
    handleFilters() {
      this.searched = true;

      this.$emit("apply-filters", {
        ...this.filters,
      });
    },

    handleClearOneFilter(fieldName) {
      this.filters[fieldName] = "";

      const hasFilters = Object.values(this.filters).some((value) => !!value);

      if (this.searched) {
        this.$emit("apply-filters", {
          ...this.filters,
        });
      }

      if (!hasFilters) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", {
        ...this.filters,
      });

      this.searched = false;
    },

    handleClearFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", {});

      this.searched = false;
    },

    async fetchDivisions() {
      try {
        const response = await DivisionService.getDivisions();

        this.divisions =
          response?.data?.map((division) => ({
            id: division.id,
            text: division.name,
          })) || [];
      } catch (error) {
        console.error("Error fetching divisions:", error);
        this.divisions = [];
      }
    },
  },

  computed: {
    isFilterApplied() {
      const hasFilters = Object.values(this.filters).some((value) => !!value);

      return this.searched && hasFilters;
    },
  },

  created() {
    this.fetchDivisions();
  },
};
</script>
